const NoteIcon = ({ width = 16, height = 16, color = '#6E6E73' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0031 7.19844V4.21844L10.3531 2.39844H3.20312V12.7984H6.40313"
        stroke={color}
        strokeWidth="1.336"
      />
      <path d="M8.79688 2.39844V5.59844H11.9969" stroke={color} strokeWidth="1.336" />
      <path d="M8 11.1992L12.8 11.1992" stroke={color} strokeWidth="1.336" />
      <path d="M10.3984 8.80078L10.3984 13.6008" stroke={color} strokeWidth="1.336" />
    </svg>
  )
}

export default NoteIcon
